import { lazy } from 'react';
import RouteTypes from '../route_types';
import { LEVEL_ONE_ADMIN_ROUTES } from '../path';
// Common Components
const CommonLayout = lazy(() => import('../../../voim/component/common/Layout'));
const NotFound = lazy(() => import('../../../voim/component/common/NotFound'));
const ChangePassword = lazy(() => import('../../../voim/component/common/ChangePassword'));
// Level One Components
// Dashboard
const Dashboard = lazy(() => import('../../../voim/component/admin/level-one-admin/dashboard'));
// Level 2
const LevelTwoList = lazy(
    () => import('../../../voim/component/admin/level-one-admin/level-two/LevelTwoList')
);
const AddLevelTwo = lazy(
    () => import('../../../voim/component/admin/level-one-admin/level-two/AddLevelTwo')
);
const ViewLevelTwo = lazy(
    () => import('../../../voim/component/admin/level-one-admin/level-two/ViewLevelTwo')
);
// School Admin
const SchoolAdminList = lazy(
    () => import('../../../voim/component/admin/level-one-admin/school-admin/SchoolAdminList')
);
// Educator
const EducatorList = lazy(
    () => import('../../../voim/component/admin/level-one-admin/educator/EducatorList')
);
// Student
const StudentList = lazy(
    () => import('../../../voim/component/admin/level-one-admin/student/StudentList')
);
// Financial Report
const FinancialReport = lazy(
    () => import('./../../../voim/component/common/Reports/FinancialReport')
);
const CustomFinancialReport = lazy(
    () => import('./../../../voim/component/common/Reports/CustomFinancialReport')
);
const PayoutReport = lazy(() => import('./../../../voim/component/common/Reports/PayoutReport'));
const LevelWiseReport = lazy(() => import('./../../../voim/component/common/LevelWiseReport'));
export default [
    // Dashboard
    {
        path: LEVEL_ONE_ADMIN_ROUTES.DASHBOARD,
        component: CommonLayout,
        pageComponent: Dashboard,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Dashboard',
        showNavigation: true,
        navMenu: true,
        active: 'dashboard',
        levelTitle: 'Level 1',
        icon: 'material-icons',
    },
    {
        path: LEVEL_ONE_ADMIN_ROUTES.LEVEL_WISE_REPORT,
        component: CommonLayout,
        pageComponent: LevelWiseReport,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Dashboard',
        showNavigation: true,
        navMenu: false,
        active: 'dashboard',
        levelTitle: 'Level 1',
    },
    // Level 2
    {
        path: LEVEL_ONE_ADMIN_ROUTES.LEVEL_TWO,
        component: CommonLayout,
        pageComponent: LevelTwoList,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Level 2',
        showNavigation: true,
        navMenu: true,
        active: 'level-two',
        levelTitle: 'Level 1',
        icon: 'fa fa-university',
    },
    {
        path: LEVEL_ONE_ADMIN_ROUTES.ADD_LEVEL,
        component: CommonLayout,
        pageComponent: AddLevelTwo,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Add Level 2',
        showNavigation: true,
        navMenu: false,
        active: 'level-two',
        levelTitle: 'Level 1',
    },
    {
        path: LEVEL_ONE_ADMIN_ROUTES.VIEW_LEVEL,
        component: CommonLayout,
        pageComponent: ViewLevelTwo,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'View Level 2',
        showNavigation: true,
        navMenu: false,
        active: 'level-two',
        levelTitle: 'Level 1',
    },
    {
        path: LEVEL_ONE_ADMIN_ROUTES.EDIT_LEVEL,
        component: CommonLayout,
        pageComponent: AddLevelTwo,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Edit Level 2',
        showNavigation: true,
        navMenu: false,
        active: 'level-two',
        levelTitle: 'Level 1',
    },
    // School Admin
    {
        path: LEVEL_ONE_ADMIN_ROUTES.BRANCH_ADMIN,
        component: CommonLayout,
        pageComponent: SchoolAdminList,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Level 3',
        showNavigation: true,
        navMenu: true,
        active: 'level-three',
        levelTitle: 'Level 1',
        icon: 'fa fa-university',
    },
    // Educator
    {
        path: LEVEL_ONE_ADMIN_ROUTES.EDUCATORS,
        component: CommonLayout,
        pageComponent: EducatorList,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Educators',
        showNavigation: true,
        navMenu: true,
        active: 'educators',
        levelTitle: 'Level 1',
        icon: 'fas fa-user-circle',
    },
    // Student
    {
        path: LEVEL_ONE_ADMIN_ROUTES.STUDENTS,
        component: CommonLayout,
        pageComponent: StudentList,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Students',
        showNavigation: true,
        navMenu: true,
        active: 'students',
        levelTitle: 'Level 1',
        icon: 'fas fa-user-graduate',
    },
    // Financial Report
    {
        path: LEVEL_ONE_ADMIN_ROUTES.FINANCIAL_REPORT,
        component: CommonLayout,
        pageComponent: FinancialReport,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: true,
        active: 'financial-reports',
        levelTitle: 'Level 1',
        icon: 'fa-solid fa-money-bill-wave',
    },
    {
        path: LEVEL_ONE_ADMIN_ROUTES.CUSTOM_FINANCIAL_REPORT,
        component: CommonLayout,
        pageComponent: CustomFinancialReport,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: false,
        active: 'financial-reports',
        levelTitle: 'Level 1',
    },
    {
        path: LEVEL_ONE_ADMIN_ROUTES.PAYOUT_REPORT,
        component: CommonLayout,
        pageComponent: PayoutReport,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: false,
        active: 'financial-reports',
        levelTitle: 'Level 1',
    },
    // Common
    {
        path: LEVEL_ONE_ADMIN_ROUTES.CHANGE_PASSWORD,
        component: CommonLayout,
        pageComponent: ChangePassword,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Change Password',
        showNavigation: false,
        navMenu: false,
        active: 'Change Password',
        levelTitle: 'Level 1',
    },
    {
        path: '*',
        component: NotFound,
        roleType: RouteTypes.LEVEL_ONE_ADMIN,
        title: 'Not Found',
        showNavigationive: false,
        navMenu: false,
        active: 'Not Found',
        levelTitle: 'Level 1',
    },
];
